import React from 'react';
import styles from '../Operations.module.css';

interface PSHRComponent extends React.FC {
  title?: string;
  actionTitle?: string;
  actionHyperlink?: string;
}

/**
 * PSHR - Help Rate (Pin Pad Survey)
 * KPI information component
 */
const PSHR: PSHRComponent = () => {
  return (
    <div className={styles.container}>

      <div className={styles.sectionTitle}>
        Metric Description
      </div>
      <div className={styles.sectionContent}>
        Measures customer responses from the pin pad survey question &quot;Did someone help you today?&quot;. The Help Rate score is the number of yes&apos;s divided by the total responses. 
      </div>

      <div className={styles.sectionTitle}>
        Supporting Details
      </div>
      <div className={styles.sectionContent}>
        Stores on <b>Epicor 35.1</b> can set <b>option setting 2154</b> to Yes to turn on this question. For more information on Help Rate: Acenet &gt; AWOR &gt; Helpful Customer Service &gt; Collect and Manage Customer Feedback with Customer & Employee Surveys & Mystery Shops      
      </div>

      <div className={styles.sectionTitle}>
        Drill Down 
      </div>
      <div className={styles.sectionContent}>
        To drill down into your Help Rate data login to the: Helpful Experience/Medallia Dashboard, change your User Role to Help Rate and review your data. You can also use the Dashboard to take a deeper dive into your data. 
      </div>

      <div className={styles.sectionTitle}>
        Learn More
      </div>
      <div className={styles.sectionContent}>
        To learn more about driving up your assistance received scores go to ACENET &gt; AWOR &gt; Helpful Experience &gt; Customer First Sales Culture. To measure your associate&apos;s behaviors utilize ARMA Customer Journey&apos;s in your store. 
      </div>
    </div>
  );
};

PSHR.title = 'Help Rate';
PSHR.actionTitle = 'Review Medallia Dashboard';
PSHR.actionHyperlink = 'https://acehardware.medallia.com/sso/acehardware';
export default PSHR;
